module.exports = __webpack_public_path__ + "img/fail-icon.73ccc416.png";